import { createRouter, createWebHistory, Router } from "vue-router";
import { routes } from "@/router/routes";

const router: Router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: routes,
  scrollBehavior(to, from) {
    if (from.name !== to.name) {
      return { top: 0 };
    }
  },
});

export default router;
